import GalleryItem from './gallery-item';
import { ISlideState } from './interfases';

interface IInitialLoopItemsProps {
    prevLoopItems: any[],
    currentLoopItems: any[],
    nextLoopItems: any[],
    slideData: ISlideState,
    renderItem: Function,
}

const InitialLoopItems = (props: IInitialLoopItemsProps) => {

    const slideData = props.slideData;
    
    return (
        <>
            {
                props.prevLoopItems.map((dataItem, i) => {
                    const idx = Math.ceil(i - slideData.itemsNumberPerSlide);

                    return (
                        <GalleryItem
                            key={ `animated-loop-prev-slide-item-${ idx }` }
                            index={ idx }
                            slideItemWidth={ slideData.slideItemWidth }
                            gap={ slideData.gap }
                            left={ (slideData.slideItemWidth + slideData.gap) * idx }
                            renderItem={ props.renderItem }
                            item={ dataItem[1] } />
                    )
                })
            }

            {
                props.currentLoopItems.map((dataItem, i) => {
                    const [index, item] = dataItem;

                    return (
                        <GalleryItem
                            key={ `animated-loop-prev-slide-item-${ index }` }
                            index={ index }
                            slideItemWidth={ slideData.slideItemWidth }
                            gap={ slideData.gap }
                            left={ slideData.currentLeftPos + (slideData.slideItemWidth + slideData.gap) * i }
                            renderItem={ props.renderItem }
                            item={ item } />
                    )
                })
            }

            {
                props.nextLoopItems.map((dataItem, i) => {
                    const idx = Math.floor(i + slideData.itemsNumberPerSlide);

                    return (
                        <GalleryItem
                            key={ `animated-loop-prev-slide-item-${ idx }` }
                            index={ idx }
                            slideItemWidth={ slideData.slideItemWidth }
                            gap={ slideData.gap }
                            left={ slideData.currentLeftPos + (slideData.slideItemWidth + slideData.gap) * idx }
                            renderItem={ props.renderItem }
                            item={ dataItem[1] } />
                    )
                })
            }
        </>
    )
};

export default InitialLoopItems;